module.exports = __webpack_public_path__ + "static/media/sun.205f98ec.svg";